import { styled, Stack } from '@/theme/index';

export const FeaturesItem = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2),
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.grey[100],
  },

  [theme.breakpoints.up('sm')]: {
    '&:nth-of-type(odd)': {
      backgroundColor: 'transparent',
    },
    '&:nth-of-type(4n+1), &:nth-of-type(4n+2)': {
      backgroundColor: theme.palette.grey[100],
    },
  },
}));
